import { render, staticRenderFns } from "./CategoriaDialog2.vue?vue&type=template&id=7b8afc36"
import script from "./CategoriaDialog2.vue?vue&type=script&lang=js"
export * from "./CategoriaDialog2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports